'use strict';
import React, { PureComponent } from 'react';
import Buscador from './Buscador'


class SeccionSuperior extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            routeToABMModelos: props.routeToABMModelos
        };

        this.routeToABMModelos = this.routeToABMModelos.bind(this);
        this.mostrarActivos = this.mostrarActivos.bind(this);
    }

    routeToABMModelos() {
        this.state.routeToABMModelos("");
    }

    mostrarActivos(valor) {
        this.props.mostrarActivos(valor);
    }

    render() {
        const { 
            checkRegistrosActivos,
            permisoAlta,
            inputBuscador
        } = this.props;

        //ACTIONS
        const { buscarModelos } = this.props;

        return (
            <div className="seccionSuperior">
                <div className="seccionSuperior__contenedorBuscador">
                    <span className="seccionSuperior__titulo">Modelos Contables</span>

                    <Buscador 
                        inputBuscador={inputBuscador}
                        buscarModelos={buscarModelos}
                    />
                </div>

                <div>
                    <div className="seccionSuperior__contenedorBoton">
                        <button className={"seccionSuperior__botonNuevo" + (permisoAlta ? "" : " seccionSuperior__botonNuevo--deshabilitado")} onClick={permisoAlta ? this.routeToABMModelos : null}>
                            Nuevo
                        </button>
                    </div>

                    <div className="seccionSuperior__contenedorCheckVisualizarVigentes">
                        <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                            <input disabled={false} type="checkbox" id={"ModelosActivos"} checked={checkRegistrosActivos} onChange={() => this.mostrarActivos(!checkRegistrosActivos)}/>
                            <label className={"label-primary Tarjetas-checkboxLabel" + (checkRegistrosActivos ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={"ModelosActivos"}></label>
                        </div>
                        <div className="label-primary seccionSuperior__divDescripcion seccionSuperior__contenedorDescripcionCheckVisualizarVigentes">Visualizar sólo registros vigentes</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SeccionSuperior;